import React, { forwardRef, ComponentClass, MutableRefObject } from 'react';
import styled from 'styled-components';
import { ClassNamePropsWithChildren } from 'components/ozone-component';
import { Breadcrumb } from './breadcrumb';
import { Title } from './title';

const SectionWrapper = styled.div`
  margin: var(--layout-03) var(--layout-02) 0 var(--layout-02);
  padding: 0 var(--spacing-03);
`;

export type HeaderShellProps = ClassNamePropsWithChildren<
  React.ElementType<HTMLDivElement>
>;

type Ref<T> =
  | ((instance: T | null) => void)
  | MutableRefObject<T | null>
  | null;

type HeaderShellType = ComponentClass<HeaderShellProps> & {
  Breadcrumb: typeof Breadcrumb;
  Title: typeof Title;
};

const HeaderShell: HeaderShellType = forwardRef(
  (props: HeaderShellProps, ref: Ref<HTMLDivElement>) => {
    const { children, className } = props;

    return (
      <SectionWrapper ref={ref} className={className}>
        {children}
      </SectionWrapper>
    );
  },
) as unknown as HeaderShellType;

HeaderShell.Breadcrumb = Breadcrumb;
HeaderShell.Title = Title;

export { HeaderShell };
